function DiagnosisVO(id, patient, attachments, visitCard, visit, icd10, mainAffliction, chronicAffliction, additionalNotes,
                     dateFrom, dateTo, author, modifiedBy, deletedBy, creationDate, modificationDate, deletionDate,
                     deleted, deletionReason, template) {
    this.id = id;

    this.patient = patient;
    this.author = author;
    this.modifiedBy = modifiedBy;
    this.deletedBy = deletedBy;
    this.creationDate = creationDate;
    this.modificationDate = modificationDate;
    this.deletionDate = deletionDate;
    this.deleted = deleted;
    this.attachments = attachments;
    this.deletionReason = deletionReason;

    this.visitCard = visitCard;
    this.visit = visit;
    this.icd10 = icd10;
    this.mainAffliction = mainAffliction;
    this.chronicAffliction = chronicAffliction;
    this.additionalNotes = additionalNotes;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.template = template;

    var _typeContext = {
        visitCard: VisitCardVO,
        visit: VisitVO,
        icd10: DictionaryElementVO,
        dateFrom: Date,
        dateTo: Date,
        patient: PatientVO,
        attachments: AttachmentVO,
        author: UserVO,
        modifiedBy: UserVO,
        deletedBy: UserVO,
        creationDate: Date,
        modificationDate: Date,
        deletionDate: Date
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
